import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Text } from 'rebass';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #F3FCFF;
  border-radius: 12px;
  border: 1px dashed #2D9CDB;
  width:150px;
`;

const Label = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.mutedText};
`;

const ButtonLabelWrap = ({ label, children }) => (
  <Wrap>
    {children}
    <Text fontFamily="Poppins" fontSize={16} lineHeight="24px" color="#64748B" >{label}</Text>
  </Wrap>
);

ButtonLabelWrap.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ButtonLabelWrap;
